import { Directive } from '@angular/core';
import { NG_VALIDATORS, Validator, FormControl, ValidationErrors } from '@angular/forms';


@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[invalidAddressCP]',
  providers: [{ provide: NG_VALIDATORS, useExisting: AdressCPValidator, multi: true }]
})
export class AdressCPValidator implements Validator {

  public static valid(c: FormControl): ValidationErrors {
    if (c.value) {
      const isValidAdressCP =  c.value.length < 6;
      return !isValidAdressCP ? { 'invalidAddressCP': true } : null;
    } else { return null; }
  }

  validate(c: FormControl): ValidationErrors {
    return AdressCPValidator.valid(c);
  }
}
